const COMPETITION_TIMEABLE_DISPLAY_STATES = [
  'instructions'
]

const TIMEABLE_DISPLAY_STATES = [
  ...COMPETITION_TIMEABLE_DISPLAY_STATES,
  'chart'
]

const BLACKLIST_DISPLAY_STATES = [
  'title'
]

const BLACKLIST_SETTINGS = [
  'static',
  'correctness'
]

const BLACKLIST_ACTIVITY_TYPE = [
  'competition',
  'leaderboard',
  'survey'
]

function containsBlackListDisplay (displaySettings = []) {
  const result = BLACKLIST_SETTINGS.filter(value => displaySettings.includes(value))
  return result && result.length
}

function isBlackListedActivity (activityType = '') {
  return BLACKLIST_ACTIVITY_TYPE.includes(activityType)
}

// I think, technically, this should be required since 'title' should be caught by
// the Competition type. However, to be safe, keep the logic the same.
function isBlackListedDisplayState (displayState = '') {
  return BLACKLIST_DISPLAY_STATES.includes(displayState)
}

function isTimeableDisplayState (displayState = '', isCompetitionMcp) {
  return isCompetitionMcp
    ? COMPETITION_TIMEABLE_DISPLAY_STATES.includes(displayState)
    : TIMEABLE_DISPLAY_STATES.includes(displayState)
}

function whyTimerDisabled (options = {}) {
  if (containsBlackListDisplay(options.displaySettings)) {
    return `blacklisted display setting: ${options.displaySettings}`
  }

  // List of activity types where the timer control is disabled.
  if (isBlackListedActivity(options.activityType)) {
    // Do not render timer if model type is not valid.
    return `disabled type: ${options.activityType}`
  }

  if (isBlackListedDisplayState(options.displayState)) {
    return `blacklisted display state ${options.displayState}`
  }

  const isTimeable = isTimeableDisplayState(options.displayState, options.isCompetitionMcp)
  return (isTimeable || options.areControlsEnabled) ? '' : `isTimeable ${isTimeable} || controlsVisible ${options.areControlsEnabled}`
}

export function canRenderTimerOptions (options = {}) {
  const disabledReason = whyTimerDisabled(options)
  return disabledReason === ''
}

export function canRenderTimer (options = {}) {
  const { activity, settings } = options
  if (!activity || !settings) { return false }

  return canRenderTimerOptions({
    activityType: activity.type && activity.type(),
    displaySettings: settings.get('display'),
    displayState: settings.get('display_state') || activity.get('display_state'),
    isCompetitionMcp: activity.competition,
    areControlsEnabled: settings.get('controls') !== 'none'
  })
}
